// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-addresses__card{margin-bottom:1rem;font-size:.9rem}.account-addresses__card label{width:100%}.account-addresses__actions{margin-top:.5rem}.account-addresses__actions .btn{margin-right:.5rem}.account-addresses__address{margin-bottom:0}.account-addresses__city,.account-addresses__line{display:block}", ""]);
// Exports
module.exports = exports;
